"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");

var _proDuotoneSvgIcons = require("@fortawesome/pro-duotone-svg-icons");

var _colors = require("../../../config/colors");

var SaveFieldButton = function SaveFieldButton(_ref) {
  var showSaving = _ref.showSaving,
      showDone = _ref.showDone;
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", null, showSaving && showDone &&
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Button, {
      className: "float-right ml-1 fa-2x",
      style: {
        border: 'none',
        color: 'rgb(74, 74, 74)',
        outline: 'none',
        boxShadow: 'none',
        backgroundColor: '#ffffff',
        cursor: 'default'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      className: "mr-1",
      icon: _proRegularSvgIcons.faCheck,
      style: {
        fontWeight: 500
      }
    }),
    /*#__PURE__*/
    _react["default"].createElement("span", {
      style: {
        fontWeight: 500,
        color: _colors.DONE_TEXT_COLOR
      }
    }, "Done")), showSaving && !showDone &&
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Button, {
      variant: "primary",
      className: "float-right ml-1 fa-2x",
      style: {
        outline: 'none',
        boxShadow: 'none'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      className: "mr-2",
      style: {
        '--fa-primary-color': _colors.SPINNER_PRIMARY_COLOR,
        '--fa-secondary-color': _colors.SPINNER_SECONDARY_COLOR
      },
      icon: _proDuotoneSvgIcons.faSpinnerThird
    }), "Saving..."), !showSaving &&
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Button, {
      type: "submit",
      variant: "primary",
      className: "float-right ml-1 fa-2x",
      "data-cy": "save-field-button",
      style: {
        outline: 'none',
        boxShadow: 'none',
        fontWeight: 500
      }
    }, "Save"))
  );
};

SaveFieldButton.defaultProps = {
  showSaving: false,
  showDone: false
};
SaveFieldButton.propTypes = process.env.NODE_ENV !== "production" ? {
  showSaving: _propTypes["default"].bool,
  showDone: _propTypes["default"].bool
} : {};

var _default = exports["default"] = SaveFieldButton;